const ItemListSchema = ({ name, items }) => ({
  "@type": "ItemList",
  "name": name,
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    ...(item.url && { "url": item.url })
  }))
});

export default ItemListSchema;